'use strict';

var Event = require('../util/event');
var interceptAjax = require('./ajax');
var interceptFetch = require('./fetch');

// capture performance and errors of Ajax (xhr & fetch) and static resources
module.exports = function (resManager) {
    var cfgManager = resManager.cfgManager;
    var captureCfg = cfgManager.get('autoCatch');
    var enableLogTrace = cfgManager.get('enableLogTrace') || false;
    var project = cfgManager.get('project');
    var resCfg = cfgManager.get('resource');
    if (captureCfg.ajax) {
        // rewrite and monitor stage change of xhr instance
        interceptAjax(enableLogTrace, project, resCfg.catchAbort, resCfg.catchTimeout);
        Event.on('ajaxCall', function () {
            resManager.parseAjax.apply(resManager, arguments);
        });
    }

    if (captureCfg.fetch) {
        interceptFetch(enableLogTrace, project);
        Event.on('fetchCall', function () {
            resManager.parseFetch.apply(resManager, arguments);
        });
    }

    if (captureCfg.resource) {
        var EVENT_LISTEN_FUNC = window.addEventListener || window.attachEvent;
        var loadName = window.addEventListener ? 'load' : 'onload';
        var errName = window.addEventListener ? 'error' : 'onerror';
        // get all static resources after page load
        if (document && document.readyState === 'complete') {
            resManager.handleResourceTiming.apply(resManager);
        } else {
            EVENT_LISTEN_FUNC(loadName, function () {
                resManager.handleResourceTiming.apply(resManager);
            });
        }

        // capture static resources load error
        EVENT_LISTEN_FUNC(errName, function (event) {
            if (event) {
                resManager.handleResourceLoadError.apply(resManager, arguments);
            }
        }, true);
    }
};